export default __webpack_public_path__ + "static/media/deleteIcon.3ee3a2a4.svg";